"use strict";

exports.__esModule = true;
exports.ComponentRemainingLifeWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _ComponentRemainingLifeElement = require("./ComponentRemainingLifeElement");
var _ComponentRemainingLifeFields = require("./ComponentRemainingLifeFields");
var _ComponentRemainingLifeHeader = require("./ComponentRemainingLifeHeader");
var _ComponentRemainingLifeThumbnail = require("./ComponentRemainingLifeThumbnail");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ComponentRemainingLifeWidget = exports.ComponentRemainingLifeWidget = {
  name: "ComponentRemainingLife",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "ComponentRemainingLifeWidget.label",
    defaultMessage: "Component Remaining Life"
  }),
  icon: "trending-up",
  group: _widgetGroups.METRIC_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "ComponentRemainingLife",
      props: Object.assign({
        width: 256,
        height: 128,
        hidePlanName: false,
        hideRemainingLife: false,
        hideCumulativeUsage: false,
        hideMaintenancePredictedOrDueDate: false,
        hideLastClosedMaintenanceDate: false
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: false,
  requiresContexts: ["device"],
  suppliesContexts: [],
  optionalProps: ["fontFamily", "fontSize", "fontWeight", "fontStyle", "textDecoration", "textAlignment"],
  requiresProps: ["x", "y", "width", "height"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 256,
      min: 32,
      max: 1024
    },
    height: {
      "default": 128,
      min: 32,
      max: 768
    }
  },
  components: {
    Element: _ComponentRemainingLifeElement.ComponentRemainingLifeElement,
    Fields: _ComponentRemainingLifeFields.ComponentRemainingLifeFields,
    Thumbnail: _ComponentRemainingLifeThumbnail.ComponentRemainingLifeThumbnail,
    Header: _ComponentRemainingLifeHeader.ComponentRemainingLifeHeader
  }
};